"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findExpireDate = exports.dateIsExpired = void 0;
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var findExpireDate = function findExpireDate(startDate, months) {
  return (0, _moment.default)(startDate).add(months, 'months');
};
exports.findExpireDate = findExpireDate;
var dateIsExpired = function dateIsExpired(date) {
  return (0, _moment.default)(date).diff((0, _moment.default)()) <= 0;
};
exports.dateIsExpired = dateIsExpired;